<div class="date-time">
    <label for="searchFromDate">Fra</label>
    <input type="text" class="styled-input-date" id="searchFromDate" name="date" placeholder="Vælg dato" required
        min="2010-01-01"
        onfocus="this.type='date'" 
        onblur="if(!this.value) { this.type='text'; }"
        (keydown)="disableTyping($event)"
        [(ngModel)]="fromDate"
        (ngModelChange)="modelChange()">   
    <i (click)="openDatePicker('searchFromDate')" class="fa fa-calendar fa-lg"></i>

    <label for="searchToDate">Til</label>
    <input type="text" class="styled-input-date" id="searchToDate" name="date" placeholder="Vælg dato" required
        onfocus="this.type='date'" 
        onblur="if(!this.value) { this.type='text'; }"
        (keydown)="disableTyping($event)"
        [(ngModel)]="toDate"
        (ngModelChange)="modelChange()">   
    <i (click)="openDatePicker('searchToDate')" class="fa fa-calendar fa-lg"></i>
</div>

<!-- Checkboxes Section -->
<div class="checkbox-group">
    <label><input type="checkbox" [value]="1" [checked]="state.includes(1)" (change)="toggleCheckboxState(1, $event)"> Nye</label>
    <label><input type="checkbox" [value]="2" [checked]="state.includes(2)" (change)="toggleCheckboxState(2, $event)"> Åbne</label>
    <label><input type="checkbox" [value]="3" [checked]="state.includes(3)" (change)="toggleCheckboxState(3, $event)"> Lukkede</label>
    <label><input type="checkbox" [value]="4" [checked]="state.includes(4)" (change)="toggleCheckboxState(4, $event)"> Genåbn.</label>
</div>

<multiselect-dropdown [items]="types" (selectionChanged)="selectionChanged($event)"></multiselect-dropdown>